export const R = {
	"EditMyInformationLabelA11y": "Rediger informasjonen min. Klikk for å åpne vinduet der du kan redigere e-post og telefonnummer.",
	"Name": "Navn",
	"Phone": "Telefon",
	"Email": "E-post",
	"Edit": "Redigér",
	"Save": "Edelsten",
	"InvalidCpr": "Vennligst skriv inn et gyldig 10-sifret personnummer.",
	"InvalidEmail": "Vennligst skriv inn en gyldig e-post.",
	"NetworkError": "Det oppstod en feil. Prøv igjen. {0}",
	"ErrorInvitePartner": "Kunne ikke invitere familiemedlemmet.",
	"PartnerEmailRequired": "Familiemedlemmets e-postadresse må fylles ut",
	"PartnerNameRequired": "Familiemedlemmets fulle navn må fylles ut",
	"PartnerCprRequired": "Familiemedlemmets CPR-nummer må fylles ut",
	"Active": "Aktiv",
	"Invited": "Invitert",
	"NoPartner": "Ingen partner",
	"AlreadyHasPartner": "Pasienten har allerede en partner",
	"InvitePartner": "Inviter familiemedlem",
	"OpenDeleteHouseholdMemberModalA11y": "Fjern husstandsmedlemmet. Klikk for å åpne vinduet der du kan bekrefte slettingen",
	"OpenEditPetModalA11y": "Rediger kjæledyr. Klikk for å åpne vinduet der du kan redigere kjæledyrets informasjon.",
	"OpenDeletePetModalA11y": "Fjern kjæledyr. Klikk for å åpne vinduet der du kan bekrefte slettingen.",
	"AddPet": "Legg til kjæledyr",
	"EditPet": "Rediger kæledyr",
	"PetName": "Kjæledyrets navn",
	"PetSex": "Kjønn og status",
	"PetRace": "Løp (valgfritt)",
	"PetRacePlaceholder": "f.eks.",
	"PetBirthdate": "Fødselsmåned og -år",
	"PetBirthdateHint": "Er du i tvil? Det beste alternativet er greit.",
	"PetType": "Type kjæledyr",
	"PetWeight": "Vekt i kilo (valgfritt)",
	"PetWeightPlaceholder": "f.eks. 5.2 eller 5.2",
	"MonthJanuary": "Januar",
	"MonthFebruary": "Februar",
	"MonthMay": "Maj",
	"MonthMarch": "Mars",
	"MonthApril": "April",
	"MonthJune": "Juni",
	"MonthJuly": "Juli",
	"MonthAugust": "August",
	"MonthSeptember": "September",
	"MonthOctober": "Oktober",
	"MonthNovember": "November",
	"MonthDecember": "Desember",
	"SelectMonth": "Velg måned",
	"SelectYear": "Velg år",
	"PetSexMale": "Han",
	"PetSexFemale": "Hun",
	"PetSexMaleNeutered": "Kastrert hann",
	"PetSexFemaleSterilized": "Sterilisert kvinne",
	"PetSexUnknown": "Ukjent",
	"PetTypeDog": "Hund",
	"PetTypeCat": "Kat",
	"PetTypeRabbit": "Kanin",
	"PetTypeRodent": "Gnaver",
	"SelectPetType": "Velg kjæledyrtype",
	"SelectPetSex": "Velg køn",
	"ConfirmAddPet": "Edelsten",
	"ConfirmEditPet": "Dater",
	"PleaseEnterPetName": "Vennligst skriv inn kjæledyrets navn",
	"PleaseSelectPetType": "Vennligst velg type kjæledyr",
	"PleaseSelectPetSex": "Vennligst velg kjønn",
	"PleaseChoosePetAge": "Velg kjæledyrets fødselsdato. Det trenger ikke å være 100 % nøyaktig.",
	"PleaseSelectMonth": "Vennligst velg måned",
	"PleaseSelectYear": "Vennligst velg år",
	"RemovePet": "Fjern kjæledyr",
	"RemovePetText": "Er du sikker på at du vil fjerne kjæledyret ditt?",
	"KeepPet": "Behold kjæledyr",
	"ErrorAddPet": "Det oppstod en feil under opprettelsen av kjæledyret ditt",
	"ErrorEditPet": "Det oppstod en feil under redigeringen av kjæledyret ditt",
	"ErrorDeletePet": "Det oppstod en feil under slettingen av kjæledyret ditt",
	"RemovePartner": "Fjern husstandsmedlem",
	"RemovePartnerText": "Er du sikker på at du vil koble fra husstandsmedlemmet ditt? Husstandsmedlemmet ditt vil fortsatt kunne bruke Hejdoktor-kontoen sin, men din delte tilgang vil bli fjernet.",
	"KeepHouseholdMember": "Behold tilknytning",
	"RemoveHouseholdMember": "Koble",
	"Partner": "partner",
	"RemoveAccess": "Ja, fjern vedlegget",
	"ErrorDeletePartner": "Det oppstod en feil under sletting av husstandsmedlemmet",
	"Profile_Description_Children": "Du kan kontakte oss på vegne av dine mindreårige barn. Opprett dem med ditt CPR-nummer og navn her.",
	"Profile_AddChild": "Legg til barn",
	"OpenEditChildModalA11y": "Rediger barn. Klikk for å åpne et vindu der du kan redigere barnets informasjon",
	"OpenDeleteChildModalA11y": "Fjern barn. Klikk for å åpne et vindu der du kan bekrefte slettingen",
	"FullName": "Fullt navn",
	"CprNumber": "CPR-nummer",
	"ProfileConfirmAddKid": "Edelsten",
	"ProfileConfirmEditKid": "Edelsten",
	"Profile_EditChild": "Rediger barn",
	"PleaseEnterFullName": "Vennligst skriv inn ditt fulle navn",
	"CprPlaceholder": "ddmmåå-xxxx",
	"CprRequired": "HLR må være fullført",
	"CprTooOld": "Beklager, denne funksjonaliteten er kun for barn under 18 år. Voksne må logge inn med egen MitID for å bestille konsultasjon.",
	"DeleteProfile": "Ja, slett profilen",
	"RemoveChildText": "Er du sikker på at du vil slette barnets profil på Hejdoktor? Denne handlingen fjerner også barnets tidligere konsultasjoner. Vær oppmerksom på at hvis du har bestilt en konsultasjon, er vi forpliktet til å lagre informasjonen din i minst 10 år.",
	"KeepProfile": "Behold profil",
	"ConfirmCprIsCorrectHeader": "Er du sikker på at CPR-nummeret er riktig?",
	"CprModulusCheckWarning": "ikke ser ut som et gyldig CPR-nummer. For å kunne registrere og skrive ut resepter må vi ha riktig CPR-nummer. Kontroller derfor at CPR-nummeret er tastet inn riktig.",
	"Back": "Tilbake",
	"ConfirmAndSave": "Bekreft og lagre",
	"RefreshDataError": "Siden kunne ikke oppdateres. Vennligst last inn på nytt.",
	"RemoveChild": "Slett barneprofil",
	"PleaseEnterANumber": "Vennligst skriv inn et tall. Du kan gjerne bruke desimaler (f.eks. 5,2 eller 5.2)"
}